import React from "react";
import { Confirmation } from "..";
import { useFeed } from "../../context/Feed";

export const HidePost = ({ feed_id }) => {
  // const [loading, setLoading] = useState(false);

  const { hidePost } = useFeed();

  return (
    <>
      <div>
        <Confirmation
          btn={
            <div className="card-body p-0 d-flex mt-2 cursor-pointer">
              <i className="feather-alert-circle text-grey-500 me-3 font-lg"></i>
              <h4 className="fw-600 text-grey-900 font-xssss mt-0 me-4">
                Hide Post
                <span className="d-block font-xsssss fw-500 mt-1 lh-3 text-grey-500">
                  Hide post from your feed
                </span>
              </h4>
            </div>
          }
          title="Are you sure you want to hide this post?"
          yesText="Yes Hide"
          noText="No"
          yesClick={() => hidePost(feed_id)}
        />
      </div>

      {/* {loading ? <Loader /> : null} */}
    </>
  );
};
